export default "__VITE_ASSET__4cc8261d__"